'use strict';

var FastClick = require('fastclick'),

    init = function init() {
        // extend fastclick to include GPlaces Autocomplete classes in needsClick list
        FastClick.prototype._needsClick = FastClick.prototype.needsClick;
        FastClick.prototype.needsClick = function(target) {
            var matchesSelector = HTMLElement.prototype.matchesSelector
                || HTMLElement.prototype.webkitMatchesSelector
                || HTMLElement.prototype.mozMatchesSelector
                || HTMLElement.prototype.msMatchesSelector;

            if (matchesSelector.call(target, '.AutoSuggestInput-item, .RadioButtonGroup .Button, input, select, .Radio span, .Checkbox span, .Radio-custom-input, .Checkbox-custom-input')) {
                return true;
            }

            return FastClick.prototype._needsClick.call(this, target);
        };

        FastClick.attach(document.body);
    };

module.exports = {
    init: init
};



// WEBPACK FOOTER //
// ./frontend/src/js/utils/sh-fastclick.js